module.exports = __webpack_public_path__ + "img/Linda Edmonds Turner in phi upsilon omicron, the choir.a9f5c027.png";